import { render, staticRenderFns } from "./threeSon.vue?vue&type=template&id=54f6c826&scoped=true"
import script from "./threeSon.vue?vue&type=script&lang=js"
export * from "./threeSon.vue?vue&type=script&lang=js"
import style0 from "./threeSon.vue?vue&type=style&index=0&id=54f6c826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f6c826",
  null
  
)

export default component.exports